import DashboardDealsListlToggle from "./DashboardDealsListlToggle";

export default DashboardDealsListlToggle;
